/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1BannerBanneridLangsIdMutationRequest,
  PutApiV1BannerBanneridLangsIdMutationResponse,
  PutApiV1BannerBanneridLangsIdPathParams,
  PutApiV1BannerBanneridLangsId400,
  PutApiV1BannerBanneridLangsId401,
  PutApiV1BannerBanneridLangsId404,
  PutApiV1BannerBanneridLangsId500,
} from "../../types/bannerIdiomasController/PutApiV1BannerBanneridLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1BannerBanneridLangsId } from "../../clients/bannerIdiomasController/putApiV1BannerBanneridLangsId.ts";

export const putApiV1BannerBanneridLangsIdMutationKey = () =>
  [{ url: "/api/v1/banner/:bannerId/langs/:id" }] as const;

export type PutApiV1BannerBanneridLangsIdMutationKey = ReturnType<
  typeof putApiV1BannerBanneridLangsIdMutationKey
>;

export function putApiV1BannerBanneridLangsIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1BannerBanneridLangsIdMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1BannerBanneridLangsIdMutationKey();
  return mutationOptions<
    PutApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerBanneridLangsId400
      | PutApiV1BannerBanneridLangsId401
      | PutApiV1BannerBanneridLangsId404
      | PutApiV1BannerBanneridLangsId500
    >,
    {
      bannerId: PutApiV1BannerBanneridLangsIdPathParams["bannerId"];
      id: PutApiV1BannerBanneridLangsIdPathParams["id"];
      data?: PutApiV1BannerBanneridLangsIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ bannerId, id, data }) => {
      return putApiV1BannerBanneridLangsId(bannerId, id, data, config);
    },
  });
}

/**
 * @description Atualiza os dados de uma tradução (idioma) de banner (multipart/form-data). **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:bannerId/langs/:id}
 */
export function usePutApiV1BannerBanneridLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1BannerBanneridLangsIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1BannerBanneridLangsId400
        | PutApiV1BannerBanneridLangsId401
        | PutApiV1BannerBanneridLangsId404
        | PutApiV1BannerBanneridLangsId500
      >,
      {
        bannerId: PutApiV1BannerBanneridLangsIdPathParams["bannerId"];
        id: PutApiV1BannerBanneridLangsIdPathParams["id"];
        data?: PutApiV1BannerBanneridLangsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1BannerBanneridLangsIdMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1BannerBanneridLangsIdMutationKey();

  const baseOptions = putApiV1BannerBanneridLangsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerBanneridLangsId400
      | PutApiV1BannerBanneridLangsId401
      | PutApiV1BannerBanneridLangsId404
      | PutApiV1BannerBanneridLangsId500
    >,
    {
      bannerId: PutApiV1BannerBanneridLangsIdPathParams["bannerId"];
      id: PutApiV1BannerBanneridLangsIdPathParams["id"];
      data?: PutApiV1BannerBanneridLangsIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerBanneridLangsId400
      | PutApiV1BannerBanneridLangsId401
      | PutApiV1BannerBanneridLangsId404
      | PutApiV1BannerBanneridLangsId500
    >,
    {
      bannerId: PutApiV1BannerBanneridLangsIdPathParams["bannerId"];
      id: PutApiV1BannerBanneridLangsIdPathParams["id"];
      data?: PutApiV1BannerBanneridLangsIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerBanneridLangsId400
      | PutApiV1BannerBanneridLangsId401
      | PutApiV1BannerBanneridLangsId404
      | PutApiV1BannerBanneridLangsId500
    >,
    {
      bannerId: PutApiV1BannerBanneridLangsIdPathParams["bannerId"];
      id: PutApiV1BannerBanneridLangsIdPathParams["id"];
      data?: PutApiV1BannerBanneridLangsIdMutationRequest;
    },
    TContext
  >;
}
